import { GarminDirectDataDigest } from "../../store";
import { timeConvert, TimeConvertType } from "../../lib";
import { Color } from "../../store/state/theme/theme_init_state";

export const AdherenceGarminDirectBbiDigestElement = (props: {
  garminDirectDataDigest?: GarminDirectDataDigest | null;
  color: Color;
}) => {
  const { garminDirectDataDigest, color } = props;
  if (garminDirectDataDigest == null) {
    return <div css={{ width: "100%", color: color.grey_160, textAlign: "center" }}> No Data</div>;
  } else if (garminDirectDataDigest) {
    return (
      <div css={{ width: "100%", color: color.black, textAlign: "center" }}>
        {
          timeConvert({
            time: garminDirectDataDigest?.wearTime
              ? Math.round(garminDirectDataDigest?.wearTime / 60000)
              : 0,
            type: TimeConvertType.formatMinutes,
          }) as string
        }
      </div>
    );
  } else {
    return <div css={{ width: "100%", color: color.grey_160, textAlign: "center" }}> </div>;
  }
};
